import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FaFileContract, 
  FaArrowLeft, 
  FaCheckCircle, 
  FaUserShield, 
  FaInfoCircle, 
  FaSignature 
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import style from './AIPolicyAppendix3.module.css';

const AIPolicyAppendix3 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className={style.pageContainer}>
      <header className={style.header}>
        <div className={style.headerContent}>
          <Link to="/ai-policy" className={style.backLink}>
            <FaArrowLeft /> Politika Belgesine Dön
          </Link>
          <div className={style.badge}>
            <FaFileContract className={style.badgeIcon} />
            <span>EK–3: KULLANICI TAAHHÜTNAMESİ</span>
          </div>
          <h1 className={style.title}>Talent14 Yapay Zekâ <br/> Kullanıcı Taahhütnamesi</h1>
          <p className={style.subtitle}>
            Öğretmenler, öğrenciler ve yöneticiler için güvenli, etik ve sorumlu yapay zekâ kullanım çerçevesi.
          </p>
        </div>
      </header>

      <main className={style.mainContent}>
        <section className={style.introSection}>
          <div className={style.docInfo}>
            <FaInfoCircle />
            <p>Bu taahhütname; Talent14 platformunu kullanan tüm öğretmenler, öğrenciler, yöneticiler ve yetkilendirilmiş kullanıcılar için geçerli olmak üzere hazırlanmıştır.</p>
          </div>
          <p className={style.mainDesc}>Bu belge ile kullanıcı, Talent14 Yapay Zekâ Politika Belgesi’nde belirtilen ilke, sınır ve kuralları okuduğunu, anladığını ve kabul ettiğini beyan eder.</p>
        </section>

        <motion.section 
          className={style.contentSection}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={itemVariants} className={style.articleCard}>
            <div className={style.articleHead}>
              <span className={style.articleNum}>1</span>
              <h2>Taahhüdün Kapsamı</h2>
            </div>
            <p>Bu taahhütname, Talent14 platformu kapsamında sunulan tüm yapay zekâ destekli araçların kullanımını kapsar. Kullanıcı, yapay zekâ özelliklerini yalnızca platform tarafından tanımlanan yetki ve sınırlar dahilinde kullanacağını kabul eder.</p>
          </motion.div>

          <motion.div variants={itemVariants} className={style.articleCard}>
            <div className={style.articleHead}>
              <span className={style.articleNum}>2</span>
              <h2>Kullanıcının Temel Taahhütleri</h2>
            </div>
            <p>Kullanıcı aşağıdaki hususları açıkça kabul ve taahhüt eder:</p>
            <ul className={style.checkList}>
              <li><FaCheckCircle /> Yapay zekâyı, öğretmenin veya eğitimcinin yerine geçecek bir araç olarak kullanmayacağını,</li>
              <li><FaCheckCircle /> Yapay zekâyı kendi yerine düşünen, üreten veya karar veren bir sistem gibi konumlandırmayacağını,</li>
              <li><FaCheckCircle /> Akademik dürüstlüğü zedeleyici, yanıltıcı veya etik dışı kullanımlardan kaçınacağını,</li>
              <li><FaCheckCircle /> Yapay zekâ çıktıylarının nihai doğruluğu ve uygunluğunun insan sorumluluğunda olduğunu,</li>
              <li><FaCheckCircle /> Yaş ve gelişim düzeyine uygun olmayan kullanım senaryolarına bilerek başvurmayacağını,</li>
              <li><FaCheckCircle /> Platform tarafından belirlenen kullanım sınırlarını ve yönlendirmeleri ihlal etmeyeceğini.</li>
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className={style.articleCard}>
            <div className={style.articleHead}>
              <span className={style.articleNum}>3</span>
              <h2>Güvenli ve Etik Kullanım Taahhüdü</h2>
            </div>
            <p>Kullanıcı aşağıdaki hususları taahhüt eder:</p>
            <ul className={style.checkList}>
              <li><FaCheckCircle /> Yapay zekâ araçlarını yalnızca eğitsel amaçlarla kullanacağını,</li>
              <li><FaCheckCircle /> Zararlı, yanıltıcı, ayrımcı veya güvenliği tehdit eden içerik üretmeyeceğini,</li>
              <li><FaCheckCircle /> Yapay zekâ kullanımında şeffaf ve izlenebilir bir davranış sergileyeceğini,</li>
              <li><FaCheckCircle /> Yapay zekânın sınırsız ve bedelsiz bir kaynak olmadığını kabul ettiğini,</li>
              <li><FaCheckCircle /> Platformun güvenlik, etik ve denetim mekanizmalarına müdahale etmeyeceğini.</li>
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className={style.articleCard}>
            <div className={style.articleHead}>
              <span className={style.articleNum}>4</span>
              <h2>Yetki, Denetim ve Sorumluluk</h2>
            </div>
            <p>Kullanıcı aşağıdaki hususları kabul eder:</p>
            <ul className={style.checkList}>
              <li><FaCheckCircle /> Yapay zekâ sistemlerinin nihai karar verici olmadığını,</li>
              <li><FaCheckCircle /> Değerlendirme, notlandırma ve yönlendirme yetkisinin insanda olduğunu,</li>
              <li><FaCheckCircle /> Talent14’ün kullanım kayıtlarını güvenlik, denetim ve iyileştirme amaçlı tutabileceğini,</li>
              <li><FaCheckCircle /> Yetki ihlali veya kötüye kullanım durumunda erişim kısıtlaması uygulanabileceğini.</li>
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className={style.articleCard}>
            <div className={style.articleHead}>
              <span className={style.articleNum}>5</span>
              <h2>Hukuki ve Kurumsal Uyum</h2>
            </div>
            <div className={style.legalInner}>
              <FaUserShield />
              <p>Kullanıcı; Talent14 Yapay Zekâ Politika Belgesi’ni, KVKK, GDPR ve ilgili mevzuat hükümlerini, ulusal ve uluslararası etik çerçeveleri dikkate alarak hareket edeceğini kabul eder.</p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className={style.articleCard}>
            <div className={style.articleHead}>
              <span className={style.articleNum}>6</span>
              <h2>İhlal ve Yaptırımlar</h2>
            </div>
            <div className={style.warnBox}>
              <p>Bu taahhütnamede yer alan ilkelere aykırı kullanım tespit edilmesi hâlinde;</p>
              <ul>
                <li>Kullanıcının yapay zekâ erişimi geçici veya kalıcı olarak sınırlandırılabilir.</li>
                <li>Kurumsal yöneticiler bilgilendirilebilir.</li>
                <li>Gerekli durumlarda hukuki ve idari süreçler başlatılabilir.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className={style.finalCard}>
            <div className={style.finalHead}>
              <FaSignature />
              <h2>7. Onay ve Kabul</h2>
            </div>
            <p>Bu belge; Talent14 platformu üzerinde dijital onay yoluyla kabul edilir. Kullanıcı, platformu kullanmaya devam ederek; Talent14 Yapay Zekâ Politika Belgesi’ni ve işbu Kullanıcı Taahhütnamesi’ni okuduğunu, anladığını ve tüm maddelerini kabul ettiğini beyan etmiş sayılır.</p>
            <div className={style.appendixNote}>Bu taahhütname, Talent14 Yapay Zekâ Politika Belgesi’nin ayrılmaz bir eki olup, EK–3 olarak yürürlüğe girer.</div>
          </motion.div>
        </motion.section>
      </main>

      <footer className={style.pageFooter}>
        <div className={style.footerContent}>
          <p>© {new Date().getFullYear()} Talent14 - Kurumsal Mevzuat ve Etik Uyumluluk</p>
        </div>
      </footer>
    </div>
  );
};

export default AIPolicyAppendix3;
